import { ENDPOINT } from '~/constants/endpoints';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import {
  type CreateUsersViaCSVPayload,
  type CreateUsersViaCSVResponse,
} from './types';
import { zodCreateUsersViaCSVResponseSchema } from './validations';

/**
 * Creates users from a CSV file.
 *
 * @param payload - The CSV file with one user per row, and whether and after
 *   how many minutes the new users get their onboarding email.
 * @param options - Additional options for the request (e.g., abort signal).
 * @returns The ids of the created users and the server's message.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Admin/operation/create_users_csv_admin_users_csv_post
 */
export const createUsersViaCSV = async (
  { file, formData }: CreateUsersViaCSVPayload,
  options?: KyRequestOptions,
) => {
  const body = new FormData();
  body.append('user_data', file);
  body.append('send_email', String(formData.sendEmail));

  if (formData.sendEmail) {
    body.append('delay_duration', String(Math.trunc(formData.delayDuration)));
  }

  return await vestigasApi
    .post(ENDPOINT.USER.CREATE_VIA_CSV(), {
      ...options,
      body,
      validate: {
        ...options?.validate,
        response: zodCreateUsersViaCSVResponseSchema,
      },
    })
    .json<CreateUsersViaCSVResponse>();
};
